import { render, staticRenderFns } from "./ProductLabelDropdown.vue?vue&type=template&id=300373f4&scoped=true&"
import script from "./ProductLabelDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductLabelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelDropdown.vue?vue&type=style&index=0&id=300373f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300373f4",
  null
  
)

export default component.exports